import { MessageSquare } from 'lucide-react';
import { Node } from '@xyflow/react';
import { Message, EventCatalogResource } from '../../types';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}

type CommandNodeData = EventCatalogResource & {
  message: Message;
};

export type CommandNode = Node<CommandNodeData, 'command'>;

export default function Command(props: CommandNode) {
  const {
    version,
    owners = [],
    producers = [],
    consumers = [],
    name,
    summary
  } = props.data.message;

  const mode = props.data.mode || 'simple';

  const nodeLabel = 'Command';

  return (
    <div className={classNames(
      "w-full rounded-md border flex justify-start bg-white text-black",
      props.selected ? "border-blue-600 ring-2 ring-blue-500 shadow-lg" : "border-blue-400"
    )}>
      <div
        className={`bg-gradient-to-b from-blue-500 to-blue-700 relative flex items-center w-5 justify-center rounded-l-sm text-blue-100 border-r-[1px] border-blue-500`}
      >
        <MessageSquare className="w-4 h-4 opacity-90 text-white absolute top-1" />
        {mode === 'full' && (
          <span
            className={"w-1/2 text-center absolute bottom-1 text-[8px] text-white font-bold uppercase tracking-[3px]"}
            style={{ transform: 'rotate(-90deg)' }}
          >
            {nodeLabel}
          </span>
        )}
      </div>
      <div className="p-1 min-w-60 max-w-[min-content]">
        <div className={classNames(mode === 'full' ? `border-b border-gray-200` : '')}>
          <span className="text-xs font-bold block pt-0.5 pb-0.5">{name}</span>
          <div className="flex justify-between">
            <span className="text-[10px] font-light block pt-0.5 pb-0.5">v{version}</span>
            {mode === 'simple' && (
              <span className="text-[10px] text-gray-500 font-light block pt-0.5 pb-0.5">{nodeLabel}</span>
            )}
          </div>
        </div>
        {mode === 'full' && (
          <div className="divide-y divide-gray-200">
            <div className="leading-3 py-1">
              <span className="text-[8px] font-light">{summary}</span>
            </div>

            <div className="grid grid-cols-2 gap-x-4 py-1">
              <span className="text-xs" style={{ fontSize: '0.2em' }}>
                Producers: {producers.length}
              </span>
              <span className="text-xs" style={{ fontSize: '0.2em' }}>
                Consumers: {consumers.length}
              </span>
              <span className="text-xs" style={{ fontSize: '0.2em' }}>
                Owners: {owners.length}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}